var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-warp"},[_c('header',{staticClass:"header",attrs:{"id":"subHeader"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"back",on:{"click":_vm.goBack}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }